import { ChainId } from '@pancakeswap/chains'
import uniq from 'lodash/uniq'

export const supportedChainIdV2 = [
  ChainId.PULSE
] as const
export const supportedChainIdV3 = [
 ChainId.PULSE
] as const
export const supportedChainId = uniq([...supportedChainIdV2, ...supportedChainIdV3])
export const bCakeSupportedChainId = [] as const

export const FARM_AUCTION_HOSTING_IN_SECONDS = 691200

export type FarmSupportedChainId = (typeof supportedChainId)[number]

export type FarmV2SupportedChainId = (typeof supportedChainIdV2)[number]

export type FarmV3SupportedChainId = (typeof supportedChainIdV3)[number]

export const masterChefAddresses: any = {
  [ChainId.PULSE]: '0x444775Ae2C82560337c86f6D62909a63381De4fd',
} as const

export const masterChefV3Addresses = {
 [ChainId.PULSE]: '0x00dF00Ad87c59ceDd8F91fa97F2D92EC77C777B9',
} as const satisfies Record<FarmV3SupportedChainId, string>

export const nonBSCVaultAddresses = {
} as const
